<template>
  <div>
    <template v-if="showCalendar === true">
      <iframe
        src="https://www.google.com/calendar/embed?showTitle=0&amp;showPrint=0&amp;showTabs=0&amp;showCalendars=0&amp;showTz=0&amp;height=600&amp;wkst=1&amp;bgcolor=%23FFFFFF&amp;src=coqquebec%40gmail.com&amp;color=%232952A3&amp;ctz=America%2FNew_York"
        style=" border-width:0 "
        width="100%"
        height="600"
        frameborder="0"
        scrolling="no"
      ></iframe>
    </template>

    <activity-entry
      v-for="activity in activities"
      :activity="activity"
      :key="activity.id"
      :show-description="showDescription"
    />

    <br />
  </div>
</template>

<script>
  import ActivityEntry from './Activite';
  import { mapGetters, mapActions } from 'vuex';
  import _ from 'lodash';

  export default {
    name: 'activities-list',
    components: { ActivityEntry },
    props: {
      limit: {
        type: Number,
        default: () => null
      },
      showDescription: {
        type: Boolean,
        default: () => true
      },
      showCalendar: {
        type: Boolean,
        default: () => true
      }
    },
    async mounted() {
      await this.fetchServices();
    },
    computed: {
      ...mapGetters('services', {
        _activities: 'activities'
      }),
      activities() {
        let activities = this._activities;
        if (!activities) {
          return activities;
        }
        activities = _.sortBy(activities, a => a.date);
        if (_.isNumber(this.limit)) {
          activities = _.slice(activities, 0, this.limit);
        }
        return _.filter(
          activities,
          a => a.type === 'normal' || a.type === 'ponctuel'
        );
      }
    },
    methods: {
      ...mapActions('services', {
        fetchServices: 'fetchServices'
      })
    }
  };
</script>

<style scoped></style>
